export const allowedCharacters = "abcdefghijklmnopqrstuvwxyz"; // Lista di caratteri consentiti
export const maxGlyphsPerColumn = 14; // Numero massimo di geroglifici per colonna
export const verticalSpacing = 0; // Imposta la distanza verticale desiderata
export const glyphDimension = 34; // Altezza di ciascun geroglifico